import { Component, OnInit, Input } from '@angular/core';
import { UserService } from '../../user.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Constants } from 'src/app/app.constants';
import { CaseAction } from './case-action';

@Component({
  selector: 'app-case-action',
  templateUrl: './case-action.component.html',
  styleUrls: ['./case-action.component.css']
})
export class CaseActionComponent implements OnInit {

  @Input() public casedata;
  public actionTypeList: any[];
  public agencyReferredList: any[];
  actionTypePlaceHolder = 'select';
  actionTypeOptions: any[];
  actionId = 0;
  actionTypeId = 0;
  agencyReferredId = 0;
  isOtherChoice = false;
  notes: string;
  caseAction = new CaseAction();
  caseActionId = 0;
  prevIndex = 0;
  isOther = false;
  isAgency = false;
  othersReason: string;

  constructor(private userService: UserService
    , public activeModal: NgbActiveModal) { }

  ngOnInit() {
    this.loadActionTypes();
    this.loadAgencyReferred();
  }

  onCancel() {
    this.activeModal.close();
  }

  private loadActionTypes() {
    this.userService.getActionTypeList(this.casedata.caseId).subscribe((actionType: any) => {
      this.actionTypeList = actionType;
      if (this.actionTypeList.length > 0) {
        this.actionTypeId = this.actionTypeList[0].actionTypeId;
        this.actionTypeChange(this.actionTypeId);
      }
    });
  }

  loadAgencyReferred() {
    this.userService.getAgencyReferredList(this.casedata.countyId).subscribe((agencyList: any) => {
      this.agencyReferredList = agencyList;
    });
  }

  actionTypeChange(actionTypeId) {
    this.userService.getActionTypeOptions(actionTypeId).subscribe((actionTypeOptions: any) => {
      this.actionTypeOptions = actionTypeOptions;
      if (this.actionTypeOptions.length > 0) {
        this.actionId = this.actionTypeOptions[0].actionId;
      }
      this.othersReason = null;
      this.agencyReferredId = 0;
    });
  }

  actionChange(action, index) {
    this.actionId = action.actionId;
    if (action.actionName === Constants.Other) {
      action.isOther = true;
      this.isOther = true;
    } else {
      this.actionTypeOptions[this.prevIndex].isOther = false;
      this.isOther = false;
      this.othersReason = null;
    }
    if (action.actionName === Constants.AgencyReferredTo) {
      action.isAgencyRefered = true;
      this.isAgency = true;
    } else {
      this.actionTypeOptions[this.prevIndex].isAgencyRefered = false;
      this.isAgency = false;
      this.agencyReferredId = 0;
    }
    this.prevIndex = index;
  }

  saveAction() {
    this.caseAction.caseActionId = this.caseActionId;
    this.caseAction.actionTypeId = this.actionTypeId;
    this.caseAction.actionId = this.actionId ? this.actionId : 0;
    this.caseAction.notes = this.notes;
    this.caseAction.caseId = this.casedata.caseId;
    this.caseAction.agencyId = this.agencyReferredId;
    this.caseAction.remarks = this.othersReason;
    this.userService.saveAction(this.caseAction).subscribe((result: any) => {
      if (result.caseActionId) {
        this.activeModal.close(result);
      }
    });
  }

}
